import { MinMaxValue } from "../../types/filters";

// logic extracted from V2
export const displayDiscreteValue = (range?: MinMaxValue) => {
  return (
    range?.min != null &&
    range?.max != null &&
    range?.min === range?.max &&
    range?.min != 0
  );
};
